import React, { useEffect, useState } from "react";
import { DialogComponent } from "../../../common/DialogComponent";
import ProtectionPlanUpgradeConfirmation from "../../../Dialogs/protectionPlan/ProtectionPlanUpgradeConfirmation";
import ProtectionPlanTrialCancellationQuestion from "../../../Dialogs/protectionPlan/ProtectionPlanTrialCancellationQuestion";
import ProtectionPlanTrialCancellationConfirmationComplete from "../../../Dialogs/protectionPlan/ProtectionPlanTrialCancellationConfirmationComplete";
import ProtectionPlanSubscriptionChangeDialog from "../../../Dialogs/protectionPlan/ProtectionPlanSubscriptionChangeDialog";
import * as ProtectionPlanActions from "../../../../store/protectionPlanService/ezs/actions";
import { useDispatch, useSelector } from "react-redux";
import ProtectionPlanUpgradePackage from "../../../Dialogs/protectionPlan/ProtectionPlanUpgradePackage";
import ProtectionPlanUpgradeCompleteDialog from "../../../Dialogs/protectionPlan/ProtectionPlanUpgradeCompleteDialog";
import { ApplicationState } from "../../../../store";
import { IPackage } from "../../../../store/protectionPlanService/ezs/types";
import ErrorBoundary from "../../../common/ErrorBoundary";
import * as httpClient from "../../../../util/httpClient";
import { GET_ACCOUNT_INFORMATION_LOADER } from "../../../../store/myAccount/types";
import * as services from "../../../../store/service";
import { Notification } from "../../../common/Notification";
import EmployeeRangeUpdateDialog from "../../../Dialogs/protectionPlan/EmployeeRangeUpdateDialog";
import { useTranslation } from "react-i18next";
interface IProps {
    initialDialog: string;
    packageIndex: number;
    onClose: any;
    subscriptionTypeChange: boolean;
    packageDetails?: any;
    removedFamilyMembers?: any;
    addedFamilyMembers?: any;
    isUserHaveTrial?: boolean;
    isPackageActive?: boolean;
    isBfsCancelFlow?: boolean;
}

let billingInfoRequestData: any = null;
let isBillingInfoChanged: boolean = false;

const creditLockServices = [
    "SVC-TU-CREDIT-LOCK",
    "SVC-TU-CREDIT-LOCK-IA",
    "SVC-TU-3B-CREDIT-LOCK",
    "SVC-TU-3B-CREDIT-LOCK-IA"
];

const EZSProtectionPlanDialogContainer: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const [billingInfoRequest, setBillingInfoRequest] = useState<any>(null);
    const [state, setState] = useState({
        packageIndex: -1,
        billingLabel: "",
        bilingAmount: 0,
        billingText: "",
        subscriptionType: "",
        subscriptionCharge: "",
        salesTax: "",
        newCharge: "",
    });
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const [subscriptionChangeDialog, setSubscriptionChangeDialog] = useState(false);
    const [upgradeConfirmationDialog, setUpgradeConfirmationDialog] = useState(false);
    const [upgradeDialog, setUpgradeDialog] = useState(false);
    const [trialCancellationQuestionDialog, setTrialCancellationQuestionDialog] = useState(false);
    const [trialCancellationCompleteDialog, setTrialCancellationCompleteDialog] = useState(false);
    const [upgradeCompleteDialog, setUpgradeCompleteDoneDialog] = useState(false);
    const [billingInfoChanged, setBillingInfoChanged] = useState(false);
    const [employeeRangeUpdate, setEmployeeRangeUpdate] = useState(false);
    const [twoStepCancellationDialog, setTwoStepCancellationDialog] = useState(false);
    const [showTwoStepCancellationDialog, setShowTwoStepCancellationDialog] = useState(false);
    const [showTwoStepCancellationTrialDialog, setShowTwoStepCancellationTrialDialog] = useState(false);

    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanState && state.protectionPlanState.protectionPlanData) {
            return state.protectionPlanState.protectionPlanData.packageList;
        }
    });
    const [newInitialDialog, setNewInitialDialog] = useState(props.initialDialog);
    const [creditLockFlag, setCreditLockFlag] = useState(false);
    const currentPackage = packageList?.find((pkg) => pkg.IsActive);
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;
    const { t: tLang } = useTranslation();

    const handleEmployeeRangeUpdateDialog = (value: string): any => {
        if (value === "open") {
            setEmployeeRangeUpdate(true);
            setUpgradeDialog(false);
        } else if (value === "close") {
            setEmployeeRangeUpdate(false);
            requestProtectionPlan(true);
            setUpgradeDialog(false);
            props.onClose();
        }
    };

    const handleSubscriptionChangeDialog = (value: string): any => {
        if (value === "show") {
            setSubscriptionChangeDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
            props.onClose();
        } else if (value === "next") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
        }
    };

    const closeSubscriptionAndShowNextDialog = () => {
        handleSubscriptionChangeDialog("next");
        if (selectedPackage?.PackagId === currentPackage?.PackagId) {
            handlePackageUpgradeDialog("show");
        } else {
            handleUpgradeConfirmationDialog("show");
        }
    };

    const handleUpgradeConfirmationDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeConfirmationDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeConfirmationDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeConfirmationDialog(false);
            props.onClose();
        }
    };

    const handleTrialQuestionDialog = (value: string): any => {
        if (value === "show") {
            setTrialCancellationQuestionDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setTrialCancellationQuestionDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setTrialCancellationQuestionDialog(false);
            props.onClose();
        }
    };

    const closeUpgradeConfirmationDialog = () => {
        setUpgradeConfirmationDialog(false);
        setNewInitialDialog("");
        document.body.classList.remove("no_scroll");
    };

    billingInfoRequestData = (billingInfoRequest && billingInfoRequest.data) || null;
    const setSaveBillingInfo = () => {
        const requestBody = {
            creditCardDetails: billingInfoRequestData && billingInfoRequestData.paymentMethod.selection === "CC" ? billingInfoRequestData.creditCard : null,
            eftDetails: billingInfoRequestData && billingInfoRequestData.paymentMethod.selection === "EFT" ? billingInfoRequestData.eft : null,
            billingAddress: billingInfoRequestData && billingInfoRequestData.billingAddress,
            paymentMode: {
                Selection: billingInfoRequestData && billingInfoRequestData.paymentMethod.selection,
            },
            inAppDetails: null,
        };
        services.saveBillingInfoUpdateTax(requestBody).then((data) => {
            setBillingInfoChanged(false);
            if (data.errors && data.errors.length > 0) {
                Notification({
                    type: "error",
                    title: tLang("manageAccount.protectionPlan.notification.title"),
                    message: data.errors[0],
                    duration: 5,
                });
            }
        });
    };
    isBillingInfoChanged = billingInfoChanged;
    const handlePackageUpgradeDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
            if (isBillingInfoChanged) {
                setSaveBillingInfo();
            }
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
            if (isBillingInfoChanged) {
                setSaveBillingInfo();
            }
            props.onClose();
        } else if (value === "submitted") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
        }
    };

    const handleTwoStepCancellationDialog = () => {
        setShowTwoStepCancellationDialog(true);
        sessionStorage.setItem("twoStepCancel", "true");
    };
    const handleTwoStepCancellationTrialDialog = () => {
        setShowTwoStepCancellationTrialDialog(true);
    };

    const closeUpgradeAndOpenCompletionDialog = (
        billingAmount: number,
        billingLabel: string,
        billingText: string,
        subscriptionType: string,
        subscriptionCharge: string,
        salesTax: string,
        newCharge: string,
    ) => {
        setState({
            ...state,
            bilingAmount: billingAmount,
            billingLabel: billingLabel,
            billingText: billingText,           
            subscriptionType,
            subscriptionCharge,
            salesTax,
            newCharge,
           

        });
        handlePackageUpgradeDialog("submitted");
        handleUpgradeDoneDialog("show");
    };

    const showPackageUpgrade = (event: any) => {
        closeUpgradeConfirmationDialog();
        if (!twoStepCancellationDialog) {
            if (props.isUserHaveTrial === true && props.isPackageActive === true) {
                handleTrialQuestionDialog("show");
            } else {
                handlePackageUpgradeDialog("show");
            }
        } else {
            if (props.isUserHaveTrial === true && props.isPackageActive === true) {
                handleTwoStepCancellationTrialDialog();
            } else {
                handleTwoStepCancellationDialog();
            }
        }
    };

    const showLogoutDialogAfterTrialCancellation = (event: any) => {
        setTrialCancellationQuestionDialog(false);
        setNewInitialDialog("");
        setTrialCancellationCompleteDialog(true);
    };

    const handleUpgradeDoneDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeCompleteDoneDialog(true);
            setUpgradeDialog(false);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeCompleteDoneDialog(false);
            setUpgradeDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeCompleteDoneDialog(false);
            setUpgradeDialog(false);
            if (
                selectedPackage &&
                selectedPackage.Products &&
                selectedPackage.Products.filter((product: any) => product.displayName === "Business Dark Web Monitoring" || product.name === "SVC-BUSINTMON")
                    .length > 0 &&
                !(accountInfo && accountInfo["_businessInformation"] && !!accountInfo["_businessInformation"]["numberOfEmployees"])
            ) {
                handleEmployeeRangeUpdateDialog("open");
            } else {
                requestProtectionPlan(true);
                setUpgradeDialog(false);
                props.onClose();
            }
        }
    };

    const loadInitialDialog = () => {
        setState({ ...state, packageIndex: props.packageIndex });
        if (newInitialDialog === "ProtectionPlanSubscriptionChangeDialog") {
            setSubscriptionChangeDialog(true);
        } else if (newInitialDialog === "ProtectionPlanUpgradeConfirmation") {
            setUpgradeConfirmationDialog(true);
        } else if (newInitialDialog === "ProtectionPlanUpgradePackage") {
            setUpgradeDialog(true);
        } else if (newInitialDialog === "ProtectionPlanTwoStepCancellation") {
            setTwoStepCancellationDialog(true);
            setUpgradeConfirmationDialog(true);
        } else if (newInitialDialog === "ProtectionPlanTrialTwoStepCancellation") {
            setTwoStepCancellationDialog(true);
            setUpgradeConfirmationDialog(true);
        } else if (newInitialDialog === "ProtectionPlanCancellation") {
            setUpgradeConfirmationDialog(true);
        }
    };

    const getAccountInformation = () => {
        httpClient
            .sendRequest("GET", "api/accountInfo/getAccountInformation")
            .then((data) => {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
                if (data && data.hasError === false) {
                    dispatch({
                        type: "GET_ACCOUNT_INFORMATION",
                        _unifiedAccountInfo: data._unifiedAccountInfo,
                    });
                }
            })
            .catch(function (error) {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
            });
    };

    useEffect(() => {
        if (props != null) {
            loadInitialDialog();
        }
    }, [props]);

    useEffect(() => {
        if ((accountInfo && accountInfo.country === "") || !!!accountInfo) {
            getAccountInformation();
        }
        
        if (currentPackage?.PackageCode === selectedPackage?.PackageCode) {
            let creditLockPresent = false;
            currentPackage.Products.forEach(product => {
                if (creditLockServices.includes(product.name)) {
                    creditLockPresent = true;
                }
            });
            setCreditLockFlag(creditLockPresent);
        }
    }, []);

    return (
        <React.Fragment>
            {state.packageIndex !== -1 && (
                <React.Fragment>
                    <ErrorBoundary componentName="Protection Plan Subscription Change Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {subscriptionChangeDialog && (
                            <DialogComponent
                                dialogId="protection-plan-subscription-change-dialog"
                                title={tLang("manageAccount.protectionPlan.subscriptionChangeTitle")}
                                datalayerEvent="Protection Plan - Close subscription type change"
                                closeDialog={() => {
                                    handleSubscriptionChangeDialog("close");
                                }}
                            >
                                <ProtectionPlanSubscriptionChangeDialog
                                    closeDialog={() => {
                                        handleSubscriptionChangeDialog("close");
                                    }}
                                    showNextDialog={closeSubscriptionAndShowNextDialog}
                                    packageIndex={state.packageIndex}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Confirmation Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeConfirmationDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-confirmation-dialog"
                                title={tLang("manageAccount.protectionPlan.upgradeConfirmationTitle")}
                                datalayerEvent="Protection Plan - Close confirmation"
                                closeDialog={() => {
                                    handleUpgradeConfirmationDialog("close");
                                }}
                            >
                                <ProtectionPlanUpgradeConfirmation
                                    closeDialog={() => {
                                        handleUpgradeConfirmationDialog("close");
                                    }}
                                     showUpgradeDialog={() => {
                                        showPackageUpgrade("show");
                                    }} 
                                    packageIndex={state.packageIndex}
                                    closeUpgradeAndOpenCompletionDialog={closeUpgradeAndOpenCompletionDialog}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                    isUserHaveTrial={props.isUserHaveTrial}
                                    creditLockPresent={creditLockFlag}
                                    isBfsCancelFlow={props?.isBfsCancelFlow || false}
                                    closeUpgradeConfirmationDialog={closeUpgradeConfirmationDialog}

                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Trial Cancellation Question Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {trialCancellationQuestionDialog && (
                            <DialogComponent
                                dialogId="protection-plan-trial-cancellation-question-dialog"
                                title={tLang("manageAccount.protectionPlan.trialCancellation.QuestionTitle")}
                                datalayerEvent="Protection Plan - Close confirmation"
                                closeDialog={() => {
                                    handleTrialQuestionDialog("close");
                                }}
                            >
                                <ProtectionPlanTrialCancellationQuestion
                                    closeDialog={() => {
                                        handleTrialQuestionDialog("close");
                                    }}
                                    showLogoutDialog={() => {
                                        showLogoutDialogAfterTrialCancellation("show");
                                    }}
                                    packageIndex={state.packageIndex}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Trial Cancellation Complete" type="showError" replaceDefaultContent={false} errorMsg="">
                        {trialCancellationCompleteDialog && (
                            <DialogComponent
                                dialogId="protection-plan-trial-cancellation-question-dialog"
                                title={tLang("manageAccount.protectionPlan.trialCancellationComplete.Title")}
                                datalayerEvent="Protection Plan - Close confirmation"
                                hideCloseButton={true}
                                noEsc={true}
                                closeDialog={() => {}}
                            >
                                <ProtectionPlanTrialCancellationConfirmationComplete
                                    packageIndex={state.packageIndex}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Package Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeDialog && (
                            <DialogComponent
                                dialogId="protection-plan-package-upgrade-dialog"
                                title={tLang("manageAccount.protectionPlan.packageUpgradeTitle")}
                                datalayerEvent="Protection Plan - Close cart summary"
                                closeDialog={() => {
                                    handlePackageUpgradeDialog("close");
                                }}
                            >
                                <ProtectionPlanUpgradePackage
                                    dialogId="protection-plan-package-upgrade-dialog"
                                    closeDialog={() => {
                                        handlePackageUpgradeDialog("close");
                                    }}
                                    packageIndex={state.packageIndex}
                                    closeUpgradeAndOpenCompletionDialog={closeUpgradeAndOpenCompletionDialog}
                                    subscriptionTypeChange={props.subscriptionTypeChange}
                                    setBillingInfoRequest={setBillingInfoRequest}
                                    setBillingInfoChanged={setBillingInfoChanged}
                                    payAsYouGoPackageDetails={props.packageDetails}
                                    removedFamilyMembers={props.removedFamilyMembers}
                                    addedFamilyMembers={props.addedFamilyMembers}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                    
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Complete Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeCompleteDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-done-dialog"
                                title={tLang("manageAccount.protectionPlan.planUpgradeDoneTitle")}
                                datalayerEvent="Protection Plan - Close completion"
                                closeDialog={() => {
                                    handleUpgradeDoneDialog("close");
                                }}
                                hideCloseButton={true}
                            >
                                <ProtectionPlanUpgradeCompleteDialog
                                    dialogId="protection-plan-upgrade-done-dialog"
                                    closeDialog={() => {
                                        handleUpgradeDoneDialog("close");
                                    }}
                                    billingLabel={state.billingLabel}
                                    billingAmount={state.bilingAmount}
                                    billingText={state.billingText}
                                    subscriptionType={state.subscriptionType}
                                    subscriptionCharge={state.subscriptionCharge}
                                    salesTax={state.salesTax}
                                    selectedPackage={selectedPackage}
                                    subscriptionTypeChange={props.subscriptionTypeChange}
                                    newCharge={state.newCharge}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                    isBfsCancelFlow={props?.isBfsCancelFlow || false}
                                />
                            </DialogComponent>
                        )}
                        {employeeRangeUpdate && (
                            <DialogComponent
                                dialogId="protection-plan-update-emp-range"
                                title={tLang("manageAccount.protectionPlan.updateEmployeeRangeTitle")}
                                datalayerEvent="Protection Plan - Update employee range"
                                closeDialog={() => {
                                    handleEmployeeRangeUpdateDialog("close");
                                }}
                                hideCloseButton={true}
                            >
                                <EmployeeRangeUpdateDialog
                                    closeDialog={() => {
                                        handleEmployeeRangeUpdateDialog("close");
                                    }}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Trial One Step Cancellation Complete" type="showError" replaceDefaultContent={false} errorMsg="">
                        {showTwoStepCancellationTrialDialog && (
                            <DialogComponent
                                dialogId="protection-plan-trial-cancellation-question-dialog"
                                title={tLang("manageAccount.protectionPlan.trialCancellationComplete.Title")}
                                datalayerEvent="Protection Plan - Close confirmation"
                                hideCloseButton={true}
                                noEsc={true}
                                closeDialog={() => {}}
                            >
                                <ProtectionPlanTrialCancellationQuestion
                                    closeDialog={() => {
                                        handleTrialQuestionDialog("close");
                                    }}
                                    showLogoutDialog={() => {
                                        showLogoutDialogAfterTrialCancellation("show");
                                    }}
                                    packageIndex={state.packageIndex}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Complete Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {showTwoStepCancellationDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-done-dialog"
                                title={tLang("manageAccount.protectionPlan.planUpgradeDoneTitle")}
                                datalayerEvent="Protection Plan - Close completion"
                                closeDialog={() => {}}
                                noEsc={true}
                                hideCloseButton={true}
                            >
                                <ProtectionPlanUpgradePackage
                                    dialogId="protection-plan-upgrade-done-dialog"
                                    closeDialog={() => {}}
                                    packageIndex={state.packageIndex}
                                    closeUpgradeAndOpenCompletionDialog={closeUpgradeAndOpenCompletionDialog}
                                    subscriptionTypeChange={props.subscriptionTypeChange}
                                    setBillingInfoRequest={setBillingInfoRequest}
                                    setBillingInfoChanged={setBillingInfoChanged}
                                    payAsYouGoPackageDetails={props.packageDetails}
                                    removedFamilyMembers={props.removedFamilyMembers}
                                    addedFamilyMembers={props.addedFamilyMembers}
                                    isTwoStepCancellation={twoStepCancellationDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default EZSProtectionPlanDialogContainer;
